import { FormLabel, Grid, Stack, Switch, Typography } from '@mui/material';

export const FieldSwitch = ({
    name,
    mainLabel,
    label1 = 'No',
    label2 = 'Si',
    checked,
    onChange,
}: {
    name: string;
    mainLabel: string;
    label1?: string;
    label2?: string;
    checked: boolean;
    onChange:
        | ((
              event: React.ChangeEvent<HTMLInputElement>,
              checked: boolean
          ) => void)
        | undefined;
}) => {
    return (
        <Grid
            container
            direction="row"
            display="flex"
            alignItems="center"
            gap={1}
        >
            <FormLabel component="legend" sx={{ textAlign: 'right' }}>
                {mainLabel}{' '}
            </FormLabel>
            <Stack direction="row" alignItems="center">
                <Typography>{label1}</Typography>
                <Switch
                    name={name}
                    checked={checked}
                    value={checked}
                    onChange={onChange}
                />
                <Typography>{label2}</Typography>
            </Stack>
        </Grid>
    );
};
